function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.921 10.5H10.08c-.86 0-1.319 1.012-.753 1.659l3.921 4.48a1 1 0 001.506 0l3.92-4.48c.567-.647.107-1.659-.752-1.659z",
  fill: "#fff",
  opacity: 0.8
});

var SvgIconIndexGrayDown = function SvgIconIndexGrayDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTE3LjkyMTIgMTAuNUgxMC4wNzg4QzkuMjE5NjEgMTAuNSA4Ljc2MDQzIDExLjUxMTkgOS4zMjYxOSAxMi4xNTg1TDEzLjI0NzQgMTYuNjM5OUMxMy42NDU4IDE3LjA5NTIgMTQuMzU0MiAxNy4wOTUyIDE0Ljc1MjYgMTYuNjM5OUwxOC42NzM4IDEyLjE1ODVDMTkuMjM5NiAxMS41MTE5IDE4Ljc4MDQgMTAuNSAxNy45MjEyIDEwLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgIconIndexGrayDown as ReactComponent };